import { useFieldContext } from "../form-context";

import { JSX } from "react";

import { OutlinedInput, SxProps } from "@mui/material";

import { BaseField } from "./BaseField";

export interface TextFieldProps {
  multiline?: boolean;
  sx?: SxProps;
  fullWidth?: boolean;
  required?: boolean;
  disabled?: boolean;
}

export function TextField({
  multiline,
  sx,
  fullWidth,
  required,
  disabled,
}: TextFieldProps): JSX.Element {
  const field = useFieldContext<string>();

  return (
    <BaseField
      sx={sx}
      fullWidth={fullWidth}
      required={required}
      disabled={disabled}
    >
      <OutlinedInput
        value={field.state.value}
        multiline={multiline}
        fullWidth={fullWidth}
        disabled={disabled}
        minRows={multiline ? 4 : undefined}
        onChange={(e) => field.handleChange(e.target.value)}
        onBlur={field.handleBlur}
      />
    </BaseField>
  );
}
